import { FONT_FAMILY, FONT_SIZE, THEME_COLORS } from "../util/themes";

export const TEXTFIELD_STYLES = {
  standard: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      fontFamily: FONT_FAMILY.primary,
      fontSize: FONT_SIZE.sm,
      '& fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
      '&:hover fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
      '&.Mui-focused fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
    },
  },
  search: {
    paddingRight: 1,
    borderRadius: 0,
    '& fieldset': {
      borderColor: 'black',
      borderWidth: '1px', 
    },
    '&:hover fieldset': {
      borderColor: 'black',
      borderWidth: '1px'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'black',
      borderWidth: '1px',
    },
  },
} as const;














